<template>
  <div id="app">
    <localization></localization>
    <v-tour name="plan-video" :steps="planVideoSteps" :callbacks="planVideoCallbacks" :options="options"></v-tour>
    <v-tour name="plan-strategy" :steps="planStrategySteps" :options="options"></v-tour>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Localization from '@/localization'

export default {
  name: 'app',
  components: { Localization },
  data() {
    return {
      options: {
        highlight: true,
        enabledButtons: {
          buttonPrevious: false,
        },
      },
      // plan video
      planVideoSteps: [
        {
          target: '.plan-video-step-1',
          content: 'Create the future of your channel here in the DASHBOARD.',
          params: {
            enableScrolling: false,
          },
        },
        {
          target: '.plan-video-step-2',
          content: 'A healthy PlannerVid dashboard looks like this.',
          params: {
            enableScrolling: false,
          },
        },
        {
          target: '.plan-video-step-3',
          content: 'But let\'s start small. Click here to plan a video.',
          params: {
            enableScrolling: false,
          },
        },
        {
          target: '.plan-video-step-4',
          content: 'When do you plan to publish this video to YouTube?',
          params: {
            highlight: false,
          },
        },
      ],
      planVideoCallbacks: {
        onStart: this.planVideoOnStart,
        onNextStep: this.planVideoShowExample,
      },
      // plan strategy
      planStrategySteps: [
        {
          target: '.plan-strategy-step-1',
          content: 'Create the future of your channel here in the DASHBOARD.',
          params: {
            enableScrolling: false,
          },
        },
        {
          target: '.plan-strategy-step-2',
          content: 'A healthy PlannerVid dashboard looks like this.',
          params: {
            enableScrolling: false,
          },
        },
      ],
    }
  },
  computed: {
    ...mapState(['settings']),
    ...mapState('user', ['authorized']),
    nextRoute() {
      return this.$route.query.redirect || '/'
    },
    currentRoute() {
      return this.$route.path
    },
  },
  mounted() {
    this.$store.dispatch('user/LOAD_CURRENT_ACCOUNT')
    this.$store.commit('SET_PRIMARY_COLOR', { color: this.settings.primaryColor })
    this.$store.commit('SET_THEME', { theme: this.settings.theme })
  },
  methods: {
    planVideoOnStart() {
      this.$store.dispatch('example/videos/getVideos')
    },
    planVideoShowExample(currentStep) {
      console.log(currentStep)
      if (currentStep === 0) {
        this.$store.commit('example/videos/showExample')
      } else if (currentStep === 1) {
        this.$store.commit('example/videos/hideExample')
        // this.$router.push('/strategy')
      }
    },
  },
  watch: {
    '$store.state.settings.theme'(theme) {
      this.$store.commit('SET_THEME', { theme })
    },
    authorized(authorized) {
      if (authorized && this.currentRoute === '/auth/login') {
        this.$router.replace(this.nextRoute)
      }
    },
    '$route'(to, from) {
      const query = Object.assign({}, to.query)
      this.$store.commit('SETUP_URL_SETTINGS', query)
    },
  },
}
</script>
